import { cn } from "@/shared/lib/utils";
import type { NotificationChannel } from "./communications-types";

/**
 * Channel pill. Each channel gets a distinct neutral/brand tint so the
 * catalog table reads at a glance. EMAIL (the always-on floor) carries the
 * brand orange; the rest stay neutral to avoid a rainbow.
 */
const VARIANT_CLASS: Record<NotificationChannel, string> = {
  EMAIL: "bg-wander-orange/15 text-wander-orange ring-wander-orange/40",
  SMS: "bg-wander-gray/15 text-wander-black ring-wander-gray/40",
  WHATSAPP: "bg-emerald-100 text-emerald-800 ring-emerald-300",
  PUSH: "bg-wander-gray/10 text-wander-black ring-wander-gray/30",
};

interface ChannelBadgeProps {
  readonly channel: NotificationChannel;
  /** Render an inactive channel muted (struck-through ring, faded). */
  readonly inactive?: boolean;
  readonly className?: string;
}

export function ChannelBadge({ channel, inactive = false, className }: ChannelBadgeProps) {
  return (
    <span
      data-testid={`communications-channel-${channel.toLowerCase()}`}
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset",
        VARIANT_CLASS[channel],
        inactive && "line-through opacity-40",
        className,
      )}
    >
      {channel}
    </span>
  );
}
